var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanAirCompliant32 = function SvgCleanAirCompliant32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.66 17.766a1.472 1.472 0 0 0-.58-.815 1.751 1.751 0 0 0-.996-.282 1.903 1.903 0 0 0-.778.152c-.227.101-.43.252-.593.44-.168.2-.295.43-.374.68a3.025 3.025 0 0 0 0 1.785c.08.249.21.478.38.676.165.183.367.328.594.425a2.036 2.036 0 0 0 1.82-.146 1.55 1.55 0 0 0 .635-.768l1.138.492a2.54 2.54 0 0 1-1.103 1.288 3.293 3.293 0 0 1-1.739.456 3.368 3.368 0 0 1-1.268-.234 2.825 2.825 0 0 1-.987-.673 2.972 2.972 0 0 1-.634-1.043c-.3-.88-.3-1.835 0-2.715.139-.391.355-.75.634-1.057.277-.297.614-.53.99-.685a3.341 3.341 0 0 1 1.269-.24 2.962 2.962 0 0 1 1.754.51c.466.327.802.808.951 1.357l-1.113.397Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 10.008c.205-.022.37.01.576.009a5.47 5.47 0 0 1 3.57 1.315 5.13 5.13 0 0 1 1.759 3.28l.219.127a5.386 5.386 0 0 1 3.227 2.026 5.059 5.059 0 0 1 .995 3.593 5.13 5.13 0 0 1-1.75 3.313A5.473 5.473 0 0 1 24.627 25H7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.132 25a5.05 5.05 0 0 1-2.945-.95 5.238 5.238 0 0 1-1.879-2.508 5.368 5.368 0 0 1-.132-3.158c.274-1.04.923-1.97 1.731-2.662h.05v-1.306A8.55 8.55 0 0 1 5.57 9.411 8.233 8.233 0 0 1 9.776 6.37a8.05 8.05 0 0 1 5.15.112c1.66.6 3.088 1.73 4.074 3.224L7.132 25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCleanAirCompliant32;